import DetailsCartFunnel from "../../components/Pages/CartFunnel/Details/Details";

const CartFunnelDetails = () => {
  return (
    <div>
      <DetailsCartFunnel />
    </div>
  );
};

export default CartFunnelDetails;
